import { prefetchAvailableProducts } from './common/providers/products-data-provider';
import {
	prefetchJoinableSites,
	type JoinableSitesDataProvider,
} from './cross-join/providers/joinable-sites-data-provider';
import prefetchSwitcherBundles from './common/utils/prefetch-bundles';
import { prefetchFlightDeck } from './common/providers/flight-deck-provider';
import { prefetchThirdPartyProducts } from './common/providers/third-party-products-data-provider';

type PrefetchAllProps = {
	cloudId?: string;
	joinableSitesDataProvider?: JoinableSitesDataProvider;
	product?: string;
};

export const prefetchAll = (props: PrefetchAllProps): void => {
	const { cloudId, product } = props;

	prefetchSwitcherBundles(product);
	prefetchFlightDeck({});
	prefetchAvailableProducts({ cloudId, product });
	prefetchThirdPartyProducts({ cloudId, product });
	prefetchJoinableSites(props.joinableSitesDataProvider);
};
